import { BannerEnum } from '../enums/bannerEnum';

export const convertBannerTypeToString = (value: BannerEnum): string => {
  switch (value) {
    case BannerEnum.LANDING_PAGE:
      return 'Landing';
    case BannerEnum.DELIVERY:
      return 'Delivery';
    // case BannerEnum.PROMOTION_FLASH_SALE:
    //   return 'Promotion flash sale';
    case BannerEnum.CATEGORY:
      return 'Category';
    case BannerEnum.PRODUCT_DETAIL:
      return 'Product detail';
    // case BannerEnum.PRE_ORDER:
    //   return 'Pre oder';
    case BannerEnum.COUPON:
      return 'Coupon';
    case BannerEnum.PROMOTION:
      return 'Promotion';
    default:
      return '';
  }
};
